import * as React from "react";
const NullCacheSummary = () => /* @__PURE__ */ React.createElement("p", null, "This cache has no configuration.");
export default NullCacheSummary;
